/**
 * Replaces internal stage name to be more understandable for the end user.
 *
 * @param text {string}: Text to potentially replace.
 *
 * @return {string}: Replaced text -- either "Pre-Sold Deal" or the original string.
 */
const replaceInternalStage = (text) => {

    if(text === 'Sold Deal'){
        return 'Pre-Sold Deal';
    } else {
        return text;
    }
};

export default replaceInternalStage;
